// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2gw88","unreadBadge":"styles_unreadBadge__25mGo","modalContent":"styles_modalContent__2YESg","modal":"styles_modal__1UIxC"};